import { Button } from 'flowbite-react';
import moment from 'moment';
import React from 'react';
import { BsArrowLeft } from 'react-icons/bs';
import { Img } from 'react-image';
import { DesktopScreenCompanyBanner } from 'src/components/scheduleMeetingDrawer';
import { Drawer } from 'src/components/shared/Drawer';
import { useUserContext } from 'src/context/UserProvider';
import BuyProgramForInterviewOrPrep from 'src/utils/BuyInterviewOrPrep';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	handleScheduling: () => void;
	hasAgreed: boolean;
}

const SchedulePaidRoundDrawer = ({ isOpen, onClose, handleScheduling, hasAgreed }: Props) => {
	const { user } = useUserContext();

	const interviewService = user?.evaluation.interviewPath;
	const discountedPrice = interviewService?.offeredPrice || 0;
	const originalPrice = interviewService?.originalPrice || 0;
	const expiry = interviewService?.expiresAt;
	const hasOfferExpired = moment(expiry).isAfter();
	return (
		<div>
			<Drawer
				isOpen={isOpen}
				onClose={onClose}
				header={<div className="h-4" />}
				body={
					<>
						<DesktopScreenCompanyBanner bgColor={'#E4E4EB'} isDrawer={true} expiry={expiry} />
					</>
				}
				footer={
					<div className="flex py-4 items-center justify-evenly">
						<Button
							color="purplePlaced"
							onClick={() => {
								onClose();
							}}
							className="border py-1 border-[#5B8DEF] bg-transparent"
						>
							<BsArrowLeft />
						</Button>

						<div className="relative">
							<BuyProgramForInterviewOrPrep
								discountedPrice={discountedPrice}
								isJapEnabled={hasAgreed}
								originalPrice={originalPrice}
								expiry={expiry}
								serviceName={'Interview Round Purchase'}
								btnText={'Schedule & Pay'}
								isForInterview={true}
								onClose={onClose}
								handleScheduleInterviewForPaidUser={handleScheduling}
							/>
							{hasOfferExpired ? (
								<div className="absolute right-[-10px] top-[-36px]">
									<Img src={'/assets/offerr.png'} />
								</div>
							) : null}
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default SchedulePaidRoundDrawer;
